import { IProfileForm } from '../../model/forms';
import { CandidateType } from '../../model/hros/recruiting';
import { DefaultTypeIdentifiersCodeList } from '../../model/hros/common/codelist/DefaultTypeIdentifiersCodeList';
import { ProfileFormContactToHROS, HROSToProfileFormContact } from './ProfileFormContactMapper';
import { ProfileFormEducationsToHROS, HROSToProfileFormEducations } from './ProfileFormEducationsMapper';
import { ProfileFormCertificationsToHROS, HROSToProfileFormCertifications } from './ProfileFormCertificationsMapper';
import { ProfileFormLicensuresToHROS, HROSToProfileFormLicensures } from './ProfileFormLicensuresMapper';
import { HROSToProfileFormEmploymentHistories, ProfileFormEmploymentHistoriesToHROS } from './ProfileFormEmploymentHistoriesMapper';
import { IEducationInstanceForm, ICertificationInstanceForm, ILicensureInstanceForm, IEmploymentHistoryInstanceForm } from '../../model/forms';

export function ProfileFormToHROSMapper(src: IProfileForm) : CandidateType {
  let candidateProfile: CandidateType = {
    profiles: [{}]
  };

  let contactResult = ProfileFormContactToHROS(src.contactInformation, candidateProfile);
  let educationResult = ProfileFormEducationsToHROS(src.educations, candidateProfile);
  let certificationResult = ProfileFormCertificationsToHROS(src.certifications, candidateProfile);
  let licensureResult = ProfileFormLicensuresToHROS(src.licensures, candidateProfile);
  let employmentHistoryResult = ProfileFormEmploymentHistoriesToHROS(src.employmentHistories, candidateProfile);

  if (contactResult || educationResult || certificationResult || licensureResult || employmentHistoryResult) {
    candidateProfile.profiles![0].profileId = {
      value: DefaultTypeIdentifiersCodeList.CANDIDATE_PROFILE_TYPE_DEFAULT,
      schemeId: DefaultTypeIdentifiersCodeList.CANDIDATE_PROFILE_TYPE_DEFAULT
    };
  }

  if (!contactResult && !educationResult && !certificationResult && !licensureResult && !employmentHistoryResult) {
    return {}; //Nothing to convert
  }

  return candidateProfile;
}

export function HROSToProfileFormMapper(src?: CandidateType) : IProfileForm | undefined {
  if (src === undefined) {
    return undefined;
  }

  let profileForm: IProfileForm = {
    contactInformation: {},
    educations: new Map<number, IEducationInstanceForm>(),
    certifications: new Map<number, ICertificationInstanceForm>(),
    licensures: new Map<number, ILicensureInstanceForm>(),
    employmentHistories: new Map<number, IEmploymentHistoryInstanceForm>()
  };

  HROSToProfileFormContact(src, profileForm.contactInformation);
  HROSToProfileFormEducations(src, profileForm.educations);
  HROSToProfileFormCertifications(src, profileForm.certifications);
  HROSToProfileFormLicensures(src, profileForm.licensures);
  HROSToProfileFormEmploymentHistories(src, profileForm.employmentHistories);

  return profileForm;
}